import React from 'react'
import { Button } from '../Buttons/Button'
import { getRows } from './util'
import getRosterPayrollExportData from './gql'
import { downloadJsonAsCsv } from '../../Utils/Misc'

const style = {
  marginLeft: 16,
}

const ExportRoster = ({ campaignId, cityId, startDate, endDate, filename }) => {
  const onClick = async () => {
    const missions = await getRosterPayrollExportData({
      campaignId,
      cityId,
      startDate,
      endDate,
    })
    if (!missions || !missions.length) {
      return alert('There is no missions to export payroll for')
    }
    const formattedRows = getRows(missions)
    return downloadJsonAsCsv(formattedRows, filename)
  }

  return (
    <Button style={style} onClick={onClick}>
      Export payroll
    </Button>
  )
}

export default ExportRoster



// WEBPACK FOOTER //
// ./src/Components/ExportRoster/index.jsx